// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    modalOpen: false,
    modalType: '',
    status: 'published',
    starred: null,
    deleted: null,
    selectedItem: {},
    attachment: '',
    attachmentSize: null,
    attachmentTotalPages: null,
    items: {},
    media: {},
    itemsPerPage: 5,
    currentPage: 1,
    paginationMeta: {
        currentPage: 1,
        itemCount: 5,
        itemsPerPage: 5,
        totalItems: 5,
        totalPages: 1
    },
    reload: false,
    draftCount: 0,
    modalAction: null,
    selectedNewItem: null,
    selectedIds: [],
    closeModalOpen: false,
    uploadingMedia: [],
    showPublishingBox: false,
    abortControllers: []
};
let dummy_items = null;

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setModalOpen:
            return {
                ...state,
                modalOpen: action.modalOpen
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setStatus:
            return {
                ...state,
                status: action.status
            };
        case actionTypes.setStarred:
            return {
                ...state,
                starred: action.starred
            };
        case actionTypes.setDeleted:
            return {
                ...state,
                deleted: action.deleted
            };
        case actionTypes.setSelectedItem:
            return {
                ...state,
                selectedItem: action.selectedItem
            };
        case actionTypes.setAttachment:
            return {
                ...state,
                attachment: action.attachment
            };
        case actionTypes.setAttachmentSize:
            return {
                ...state,
                attachmentSize: action.AttachmentSize
            };
        case actionTypes.setAttachmentTotalPages:
            return {
                ...state,
                attachmentTotalPages: action.attachmentTotalPages
            };
        case actionTypes.setItems:
            return {
                ...state,
                items: action.items
            };
        case actionTypes.setMedia:
            return {
                ...state,
                media: action.media
                // media: action.media
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setPaginationMeta:
            return {
                ...state,
                paginationMeta: action.paginationMeta
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setDraftCount:
            return {
                ...state,
                draftCount: action.draftCount
            };
        case actionTypes.setModalAction:
            return {
                ...state,
                modalAction: action.modalAction
            };
        case actionTypes.setSelectedNewItem:
            return {
                ...state,
                selectedNewItem: action.selectedNewItem
            };
        case actionTypes.setSelectedIds:
            if (action.singleItem === false) {
                if (action.singleItem !== state.singleItem) {
                    dummy_items = [];
                }
                if (action.action && action.action === 'remove') {
                    dummy_items = dummy_items.filter(function (value, index, arr) {
                        return value != action.selectedIds;
                    });
                } else {
                    dummy_items.push(action.selectedIds);
                }
            } else {
                dummy_items = action.selectedIds;
            }
            return {
                ...state,
                selectedIds: dummy_items,
                singleItem: action.singleItem
            };
        case actionTypes.setCloseModalOpen:
            return {
                ...state,
                closeModalOpen: action.closeModalOpen
            };
        case actionTypes.setUploadingMedia:
            return {
                ...state,
                uploadingMedia: action.uploadingMedia
            };
        case actionTypes.setPublishingBox:
            return {
                ...state,
                showPublishingBox: action.showPublishingBox
            };
        case actionTypes.setAbortControllers:
            return {
                ...state,
                abortControllers: action.abortControllers
            };
        default:
            return state;
    }
};

export default customizationReducer;
